import React from 'react';
import styles from './styles.module.scss';
import { useFallbackId } from '../../useFallbackId';
import Checkbox from '../Checkbox';
import { HtmlFieldset, HtmlFieldsetProps } from '../HtmlFieldset';

type AllowedHtmlFieldsetProps = Omit<HtmlFieldsetProps, 'onChange' | 'label' | 'value'>;

export type CheckboxSelectProps<Type> = {
    id?: string;
    label?: string;
    value: Array<Type>;
    onChange: (newValue: Array<Type>) => void;
    options: Array<{
        label: string;
        value: Type;
    }>;
    comparator?: (item1: Type, item2: Type) => boolean;
} & AllowedHtmlFieldsetProps;

const defaultComparator = (item1: any, item2: any) => {
    return item1 === item2;
};

export const CheckboxSelect = <Type,>({
    id,
    label,
    value,
    onChange,
    options,
    comparator: comparator = defaultComparator,
    onBlur,
    ...fieldsetProps
}: CheckboxSelectProps<Type>) => {
    const inputId = useFallbackId(id);

    return (
        <HtmlFieldset className={styles.container} label={label} onBlur={onBlur} {...fieldsetProps}>
            {options.map((option, index) => {
                const isChecked = value.some((selectedValue) => {
                    return comparator(selectedValue, option.value);
                });
                const handleChange = (checked: boolean) => {
                    if (checked) {
                        const newValue = [...value, option.value];
                        onChange(newValue);
                    } else {
                        const newValue = value.filter((value) => {
                            return comparator(value, option.value) === false;
                        });
                        onChange(newValue);
                    }
                };
                return (
                    <Checkbox
                        key={JSON.stringify(option.value)}
                        id={`${inputId}-option-${index}`}
                        isChecked={isChecked}
                        onChange={handleChange}
                        label={option.label}
                        className={styles.checkbox}
                    />
                );
            })}
        </HtmlFieldset>
    );
};

export default CheckboxSelect;
